// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PRE7","questions":"styles_questions__3OFYu","footer":"styles_footer__2E9Ls"};